import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=anon, obj=auth
  const [matrix, setMatrix] = useState({});

  const loadMatrix = useCallback(async () => {
    try {
      const { data } = await api.get("/rbac/permissions");
      setMatrix(data.matrix || {});
    } catch (err) {
      console.error("Failed to load permission matrix:", err);
    }
  }, []);

  const checkAuth = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      loadMatrix();
    } catch (_) {
      setUser(false);
    }
  }, [loadMatrix]);

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) return; // AuthCallback handles it
    checkAuth();
  }, [checkAuth]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
    loadMatrix();
    return data;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    setUser(data);
    loadMatrix();
    return data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (err) { console.error("Logout error:", err); }
    setUser(false);
  };

  const hasPerm = useCallback(
    (perm) => {
      if (!user) return false;
      if (user.role === "admin") return true;
      return (matrix[perm] || []).includes(user.role);
    },
    [user, matrix]
  );

  return (
    <AuthContext.Provider value={{ user, setUser, login, register, logout, hasPerm, checkAuth }}>
      {children}
    </AuthContext.Provider>
  );
}
